import types from "@/data/types"

const ticketHeaders = (type) => {
    switch (type) {
        case types.OSS_API:
        case types.OSS_WEB:
            return [
                'team', 'account_user', 'event_id', 'event',
                'date', 'time', 'section', 'row', 'seat', 'barcode', 'additional', 'ticket_id',
            ]
        case types.OSS_API_INVENTORY:
        case types.OSS_WEB_INVENTORY:
            return [
                'team', 'account_user', 'event_id', 'event',
                'date', 'time', 'section', 'row', 'seat',
            ]
        case types.TM_PHONE:
            return [
                'team', 'event', 'section', 'row', 'seat', 'barcode', 'venue', 'date', 'time'
            ]
        case types.SG:
            return [
                'account_user', 'date', 'time', 'section', 'row', 'seat',
                'event_id', 'team', 'event', 'year', 'venue', 'barcode'
            ]
        case types.OSS_CREDITS:
            return [
                'account_user', 'credit_amount', 'resale_credit'
            ]
        case types.BALLPARK_APP:
        case types.BALLPARK_WEB:
            return [
                'account_user', 'account_number', 'date', 'year', 'time', 'section', 'row', 'seat',
                'event_id', 'teams', 'alternative', 'venue', 'barcode', 'ticket_id'
            ]
        case types.PACIOLAN_SCRAPE:
            return [
                'account', 'date', 'time', 'section', 'row', 'seat', 'event_id', 'team', 'event', 'year', 'venue', 'barcode'
            ]
        case types.TM_AM_SCRAPE:
            return [
                'team', 'account', 'eventid', 'eventtitle', 'date', 'time', 'venue', 'section', 'row', 'seat', 'barcode', 'canResale'
            ]
        case types.SEATGEEK_SCRAPE:
            return [
                'account', 'ticket_sid', 'event', 'date', 'time', 'venue', 'section', 'row', 'seat', 'barcode'
            ]
        default:
            console.warn("No ticket header for the type: ", type)
    }
}

export default ticketHeaders
